import { request } from '@mairistem/tools';

import { downloadDocument } from '@/routes';

/**
 * Déclenche l'enregistrement d'un fichier par le navigateur
 * @param blob - Contenu du fichier
 * @param fileName - Nom proposé à l'enregistrement
 */
export const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);

  const link = window.document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
  link.remove();
};

/**
 * Télécharge un document de la régie et l'enregistre sous le nom donné.
 *
 * `request.download` n'est pas utilisé : il lit le nom dans l'en-tête `Content-Disposition`,
 * que le navigateur masque quand l'app est servie sur un autre domaine que l'API (CORS).
 * @param identifiantDocument - Identifiant du document
 * @param fileName - Nom proposé à l'enregistrement
 */
export const downloadDocumentFile = async (identifiantDocument: number, fileName: string) => {
  const blob = await request.get<never, Blob>(downloadDocument(identifiantDocument), {
    headers: { Accept: '*/*' },
    responseType: 'blob',
  });

  saveBlob(blob, fileName);
};
